import { BaseDto } from "@/shared/dtos/base-dto";

export class alegacion extends BaseDto {
  public id_lote_fk!: number;
  public id_modificacion_fk!: number;
  public id_empleado_fk!: number;
  public fecha_hora_accion!: Date;
  public estado_respuesta!: string; // 'ACEPTADA' | 'DISCREPANCIA'
  public texto_alegacion!: string;
  public medio_autorizacion!: string;

  constructor(src?: any, enableTrackChanges: boolean = false) {
    super(src, enableTrackChanges);
  }
}
